import React from 'react';
import './News.css'; 
import { Heading } from '../../../components';
import { images } from '../../../constants';
import news from '../../../constants/newsData'; 

import { Autoplay, Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';
import 'swiper/css/pagination';

const fallbackImages = [
    images.news1,
    images.news2,
    images.news3,
    images.news4,
    images.news5,
    images.news6,
];

const getFallbackImage = (itemId) => fallbackImages[(itemId - 1) % fallbackImages.length];

const News = () => {
    return (
        <section className='news-section' id='aktualnosci'>
            <Heading title={'Aktualności'} subTitle={'O nas w mediach'} />

            <Swiper
                modules={[Autoplay, Pagination]}
                spaceBetween={30}
                loop={true}
                pagination={{ clickable: true }}
                autoplay={{ delay: 5000, disableOnInteraction: false }}
                breakpoints={{
                    450: { slidesPerView: 1 },
                    768: { slidesPerView: 2 },
                    1100: { slidesPerView: 3 },
                }}
            >
                {news.map((item) => (
                    <SwiperSlide key={item.id}>
                        <div className='news-card'>
                            <div className='news-image'>
                                <img 
                                    src={
                                        item.image 
                                            ? item.image 
                                            : `https://api.microlink.io/?url=${encodeURIComponent(item.link)}&embed=image.url`
                                    }
                                    alt={item.title} 
                                    onError={(e) => {
                                        e.target.onerror = null;
                                        e.target.src = getFallbackImage(item.id);
                                    }}
                                />
                                <span className='news-source'>{item.source}</span>
                            </div>
                            <div className='news-body'>
                                <h4>{item.title}</h4>
                                <p>{item.content}</p>
                                <a
                                    href={item.link}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className='news-link'
                                >
                                    Czytaj artykuł →
                                </a>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>
        </section>
    );
};

export default News;